<template>
    <div>
      <template v-for="field in references[method]">
        <div :key="field.code" v-if="field.data && field.code === expertModel.refCode">
          <template v-for="childField in field.data.childFields || []">
            <div class="form-group" :key="childField.code">
              <template v-if="childField.type === 'TEXT' && childField.code !== 'ANALOGS'">
                 <textarea cols="30" rows="3"
                           v-model="expertModel.comment"
                           class="form-control"
                           placeholder="Изохни киритинг"
                           :disabled="!childField.editable"
                           @input="handleInput"
                           @change="handleInput"
                 ></textarea>
              </template>
              <template v-else-if="childField.type === 'MULTISELECT' && childField.code !== 'ANALOGS' && expertModel[childField.code]">
                <treeselect
                    class="form-control"
                    v-model="expertModel.selected"
                    :multiple="true"
                    placeholder="Танланг..."
                    :options="expertModel[childField.code]"
                    :normalizer="normalizer"
                    @input="selectedIds => onInputCommentValue(selectedIds, expertModel, childField)"
                ></treeselect>
              </template>
            </div>
          </template>
        </div>
      </template>
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";

export default {
  name: "Expert2CommentEdit",
  components: {Treeselect},
  props: {
    expert: {
      type: Object,
      default: () => {}
    },
    references: {
      type: Object,
      default: () => {}
    },
    method: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      expertModel: this.$props.expert
    }
  },
  methods: {
    normalizer(node) {
      return {
        id: node.id,
        label: node.name,
        children: node.children,
      }
    },
    handleInput(value) {
      this.expertModel = value
      this.$emit("update:expert", this.expertModel)
    },
    onInputCommentValue(selectedIds, expert, childField) {
      const flatNodes = this.flattenOptions(expert[childField.code])
      expert.comments = flatNodes.filter(node => selectedIds.includes(node.id))

      this.onSetComment(expert, childField)

      this.$emit("update:expert", expert)
    },
    flattenOptions(nodes) {
      let result = []
      nodes.forEach(node => {
        result.push(node)
        if (node.children && node.children.length) {
          result = result.concat(this.flattenOptions(node.children))
        }
      })
      return result
    },
    onSetComment(expert, childField) {
      const groups = {}
      const parts = []

      expert.comments.forEach(item => {
        if (item.children && item.children.length) {
          parts.push(item.name)
          return
        }

        if (item.parent) {
          const key = item.parent.code
          if (!groups[key]) {
            const parentNode = expert[childField.code].find(c => c.code === key)
            const total = parentNode && parentNode.children ? parentNode.children.length : null

            groups[key] = {
              name: item.parent.name,
              total,
              codes: [],
            }
          }
          groups[key].codes.push(item.code)
        } else {
          parts.push(item.name)
        }
      })

      Object.values(groups).forEach(group => {
        let text

        if (group.total !== null && group.codes.length === group.total) {
          text = group.name.replace(/\(([^)]*аналог[^)]*)\)/i, (match, word) => word)
        } else {
          const numbers = group.codes.join('-')
          text = group.name.replace(/\(([^)]*аналог[^)]*)\)/i, (match, word) => {
            if (group.codes.length === 1) {
              const singularWord = word.replace(/лар$/i, '')
              return `${numbers}-${singularWord}`
            }
            return `${numbers}-${word}`
          })
        }

        parts.push(text)
      })

      const cleanedParts = parts.map(text =>
          text.replace(/\(([^)]*аналог[^)]*)\)/gi, (match, word) => word)
      )

      expert.comment = cleanedParts.join(' ')
    }
  },
  watch: {
    expert: {
      handler: function (val) {
        this.expertModel = val
      }
    }
  }
}
</script>

<style scoped>

</style>